//统一管理postMessage
import Vue from '../../main'
function postMessage(e){
    if(e.origin == 'http://test.course.lh.forclass.net:81')return
    if(!Vue.isValid(e.data))return
    let data = e.data
    if(data.type == 'router'){
        Vue.$router[data.data.action]({path:data.data.param.path,query:data.data.param.param})
    }
}
export{
    postMessage
}


// WEBPACK FOOTER //
// ./src/assets/js/postMessageApi.js